import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

//DataTable
import { StructureTableColumn } from "../../../Data/DataTables/OrgStructure";
import { ViewCompanyProfile } from "../../../Types/CompanyProfile/CompanyProfile";
import { ViewDepartments } from "../../../Types/CompanyProfile/Department";

//Services
import {
  VIEW_DEPARTMENT_QUERY_KEY,
  departmentService,
} from "../../../Services/departmentService";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const DepartmentTable = ({ companyInfo }: CompanyDataProps) => {
  const company_code = companyInfo?.code || "";
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const departmentQueryKey = [...VIEW_DEPARTMENT_QUERY_KEY, company_code];

  const { data: DepartmentData = [], isLoading: isDepartmentLoading } =
    useQuery<ViewDepartments[]>({
      queryKey: departmentQueryKey,
      queryFn: () =>
        departmentService.getAllViewDepartmentByCompany(company_code as string),
      select: (data) =>
        data.sort((a, b) =>
          a.division_name
            .toLowerCase()
            .localeCompare(b.division_name.toLowerCase()),
        ),
    });

  const filteredItems: ViewDepartments[] = DepartmentData.filter(
    (item) =>
      item.status === 1 &&
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  return (
    <>
      <br />
      <H5 className="mb-1">Structure Overview</H5>
      <P className="mb-3 f-light f-w-200 f-12">
        Displays all <b>active</b> divisions and their corresponding departments
        currently set up in the system.
      </P>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive theme-scrollbar">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={StructureTableColumn}
          striped={true}
          pagination
          progressPending={isDepartmentLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default DepartmentTable;
